/* PIC AL MAYOR — animaciones del rediseño. Sin librerías. */
(function () {
  'use strict';
  if (window.__PM_REDESIGN__) return;
  window.__PM_REDESIGN__ = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('pm-js');

  function init(root) {
    root = root || document;

    /* Scroll reveal escalonado 80 ms */
    var reveals = root.querySelectorAll('.pm-reveal:not([data-pm-seen])');
    if (reveals.length) {
      if (reduce || !('IntersectionObserver' in window)) {
        Array.prototype.forEach.call(reveals, function (el) {
          el.setAttribute('data-pm-seen', '1');
          el.classList.add('is-in');
        });
      } else {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            var el = e.target;
            var sibs = Array.prototype.filter.call(el.parentElement.children, function (c) {
              return c.classList.contains('pm-reveal');
            });
            setTimeout(function () { el.classList.add('is-in'); }, sibs.indexOf(el) * 80);
            io.unobserve(el);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
        Array.prototype.forEach.call(reveals, function (el) {
          el.setAttribute('data-pm-seen', '1');
          io.observe(el);
        });
      }
    }

    /* Contadores */
    var counters = root.querySelectorAll('[data-pm-count]:not([data-pm-done])');
    function run(el) {
      if (el.getAttribute('data-pm-ran')) return;
      el.setAttribute('data-pm-ran', '1');
      var to = parseFloat(el.getAttribute('data-pm-count'));
      var dec = parseInt(el.getAttribute('data-pm-dec') || '0', 10);
      var fmt = function (v) { return v.toFixed(dec).replace('.', ','); };
      if (reduce) { el.textContent = fmt(to); return; }
      var t0 = performance.now();
      (function step(now) {
        var p = Math.min(1, (now - t0) / 1100);
        el.textContent = fmt(to * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
      })(performance.now());
    }
    if (counters.length) {
      if (!('IntersectionObserver' in window)) {
        Array.prototype.forEach.call(counters, run);
      } else {
        var cio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            run(e.target);
            cio.unobserve(e.target);
          });
        }, { threshold: 0.25 });
        Array.prototype.forEach.call(counters, function (el) {
          el.setAttribute('data-pm-done', '1');
          cio.observe(el);
        });

      }
    }

    /* Hero: carrusel automático */
    var heroEl = root.querySelector('[data-pm-hero]:not([data-pm-slider])');
    if (heroEl) {
      heroEl.setAttribute('data-pm-slider', '1');
      var slides = heroEl.querySelectorAll('[data-pm-slide]');
      var dots = heroEl.querySelectorAll('[data-pm-dot]');
      if (slides.length > 1) {
        var cur = 0;
        var ms = (parseFloat(heroEl.getAttribute('data-pm-interval')) || 6) * 1000;
        var show = function (n) {
          cur = (n + slides.length) % slides.length;
          for (var i = 0; i < slides.length; i++) slides[i].classList.toggle('is-active', i === cur);
          for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-active', k === cur);
        };
        var timer = setInterval(function () { show(cur + 1); }, ms);
        var restart = function () { clearInterval(timer); timer = setInterval(function () { show(cur + 1); }, ms); };
        Array.prototype.forEach.call(dots, function (d) {
          d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-pm-dot'), 10)); restart(); });
        });
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) clearInterval(timer);
          else restart();
        });
      }
    }

    /* Hero: parallax + seguimiento del puntero */
    var hero = root.querySelector('[data-pm-hero]:not([data-pm-bound])');
    if (hero && !reduce) {
      hero.setAttribute('data-pm-bound', '1');
      var par = hero.querySelector('.pm-hero__par');
      var ptr = hero.querySelector('.pm-hero__ptr');
      var base = 'none';
      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = Math.max(0, Math.min(window.scrollY, 800));
          if (par) par.style.transform = 'translate3d(0,' + (y * 0.14).toFixed(1) + 'px,0)';
          ticking = false;
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      function track(e) {
        var r = hero.getBoundingClientRect();
        var dx = (e.clientX - r.left) / r.width - 0.5;
        var dy = (e.clientY - r.top) / r.height - 0.5;
        base = 'translate3d(' + (-dx * 20).toFixed(1) + 'px,' + (-dy * 15).toFixed(1) + 'px,0) scale(1.05)';
        if (ptr) ptr.style.transform = base;
      }
      hero.addEventListener('pointermove', track);
      hero.addEventListener('pointerdown', function (e) {
        track(e);
        if (ptr) ptr.style.transform = base + ' scale(1.03)';
      });
      hero.addEventListener('pointerup', function () { if (ptr) ptr.style.transform = base; });
      hero.addEventListener('pointerleave', function () {
        base = 'none';
        if (ptr) ptr.style.transform = 'none';
      });
    }

    /* Vídeo: activar o silenciar el sonido (arranca silenciado para permitir el autoplay) */
    Array.prototype.forEach.call(root.querySelectorAll('[data-pm-sound]:not([data-pm-bound])'), function (btn) {
      btn.setAttribute('data-pm-bound', '1');
      var wrap = btn.closest('.pm-video') || btn.parentElement;
      var vid = wrap ? wrap.querySelector('video') : null;
      if (!vid) { btn.hidden = true; return; }
      var label = btn.querySelector('span');
      var icon = btn.querySelector('b');
      var paint = function () {
        var on = !vid.muted && vid.volume > 0;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-label', on ? 'Silenciar el vídeo' : 'Activar el sonido del vídeo');
        if (label) label.textContent = on ? 'Silenciar' : 'Activar sonido';
        if (icon) icon.innerHTML = on ? '&#128266;' : '&#128263;';
      };
      btn.addEventListener('click', function () {
        var encender = vid.muted;
        if (encender) {
          /* un solo audio a la vez si la sección está duplicada */
          Array.prototype.forEach.call(document.querySelectorAll('video'), function (o) {
            if (o !== vid) o.muted = true;
          });
          Array.prototype.forEach.call(document.querySelectorAll('[data-pm-sound]'), function (o) {
            if (o !== btn) {
              o.setAttribute('aria-pressed', 'false');
              var l = o.querySelector('span'); if (l) l.textContent = 'Activar sonido';
              var i = o.querySelector('b'); if (i) i.innerHTML = '&#128263;';
            }
          });
        }
        vid.muted = !encender;
        if (encender && vid.volume === 0) vid.volume = 1;
        /* no reiniciar: solo reanudar si el navegador lo había pausado */
        if (vid.paused) { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); }
        paint();
      });
      vid.addEventListener('volumechange', paint);
      paint();
    });

    /* FAQ: + / − */
    Array.prototype.forEach.call(root.querySelectorAll('.pm-faq details:not([data-pm-bound])'), function (d) {
      d.setAttribute('data-pm-bound', '1');
      d.addEventListener('toggle', function () {
        var i = d.querySelector('summary i');
        if (i) i.textContent = d.open ? '\u2212' : '+';
      });
    });

    /* Elige tu marca: carrusel por marca */
    Array.prototype.forEach.call(root.querySelectorAll('[data-pm-bz]:not([data-pm-bound])'), bindBrands);
  }

  var desk = window.matchMedia('(min-width: 768px)');

  function bindCarousel(panel) {
    var vp = panel.querySelector('[data-pm-bz-viewport]');
    var prev = panel.querySelector('[data-pm-bz-prev]');
    var next = panel.querySelector('[data-pm-bz-next]');
    if (!vp || !prev || !next) return function () {};
    var queued = false;

    function update() {
      queued = false;
      var max = vp.scrollWidth - vp.clientWidth;
      var atStart = vp.scrollLeft <= 2;
      var atEnd = vp.scrollLeft >= max - 2;
      /* si el bot\u00f3n con el foco se desactiva, el foco pasa al otro en vez de perderse */
      if (atStart && document.activeElement === prev && !atEnd) next.focus();
      if (atEnd && document.activeElement === next && !atStart) prev.focus();
      prev.disabled = atStart;
      next.disabled = atEnd;
      panel.classList.toggle('is-static', max <= 2);
    }
    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }
    function page(dir) {
      var item = vp.querySelector('.pm-bz__item');
      var track = item && item.parentElement;
      var gap = track ? parseFloat(getComputedStyle(track).columnGap) || 0 : 0;
      var step = item ? item.getBoundingClientRect().width + gap : vp.clientWidth;
      var per = Math.max(1, Math.floor((vp.clientWidth - 24 + gap) / step));
      vp.scrollBy({ left: dir * per * step, behavior: reduce ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    vp.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    update();
    return update;
  }

  function bindBrands(wrap) {
    wrap.setAttribute('data-pm-bound', '1');
    var tabs = Array.prototype.filter.call(wrap.querySelectorAll('[data-pm-bz-tab]'), function (t) {
      return document.getElementById(t.getAttribute('data-pm-bz-tab'));
    });
    if (!tabs.length) return;
    var refresh = {};

    tabs.forEach(function (t) {
      var panel = document.getElementById(t.getAttribute('data-pm-bz-tab'));
      refresh[panel.id] = bindCarousel(panel);
    });

    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        var panel = document.getElementById(t.getAttribute('data-pm-bz-tab'));
        t.classList.toggle('is-active', on);
        panel.classList.toggle('is-active', on);
        /* en m\u00f3vil todos los carruseles est\u00e1n a la vista */
        t.setAttribute('aria-expanded', on || !desk.matches ? 'true' : 'false');
        if (on) refresh[panel.id]();
      });
    }

    function sync() {
      wrap.classList.toggle('has-active', desk.matches);
      var current = tabs.filter(function (t) { return t.classList.contains('is-active'); })[0];
      select(current || tabs[0]);
      Object.keys(refresh).forEach(function (id) { refresh[id](); });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        /* en m\u00f3vil la tarjeta sigue llevando a la colecci\u00f3n */
        if (!desk.matches || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
        e.preventDefault();
        if (!t.classList.contains('is-active')) select(t);
      });
      /* Intro y Espacio: la tarjeta se comporta como un selector */
      t.addEventListener('keydown', function (e) {
        if (!desk.matches || (e.key !== 'Enter' && e.key !== ' ')) return;
        e.preventDefault();
        if (!t.classList.contains('is-active')) select(t);
      });
      /* el personalizador selecciona el bloque: mostrar su carrusel */
      t.addEventListener('shopify:block:select', function () { if (desk.matches) select(t); });
    });

    if (desk.addEventListener) desk.addEventListener('change', sync);
    else if (desk.addListener) desk.addListener(sync);
    sync();
  }

  /* Pulso al pulsar (delegado: funciona con contenido inyectado) */
  document.addEventListener('pointerdown', function (e) {
    if (reduce) return;
    var t = e.target.closest ? e.target.closest('.pm-btn, .pm-card') : null;
    if (!t) return;
    t.classList.remove('is-pressed');
    void t.offsetWidth;
    t.classList.add('is-pressed');
    setTimeout(function () { t.classList.remove('is-pressed'); }, 320);
  }, true);

  /* Menú móvil: marca el estado abierto (oculta el flotante), cierra al pulsar un enlace
     y no deja rastro de bloqueo de scroll cuando se cierra. */
  function pmMenu() {
    var det = document.getElementById('Details-menu-drawer-container');
    if (!det || det.dataset.pmBound) return;
    det.dataset.pmBound = '1';
    var marca = function () {
      document.documentElement.classList.toggle('pm-menu-abierto', det.hasAttribute('open'));
    };
    det.addEventListener('toggle', marca);
    marca();
    det.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('.pmm a[href]') : null;
      if (!a || a.target === '_blank') return;
      det.removeAttribute('open');
      document.documentElement.classList.remove('pm-menu-abierto');
    });
    if ('MutationObserver' in window) {
      new MutationObserver(marca).observe(det, { attributes: true, attributeFilter: ['open'] });
    }
  }

  /* Los acordeones del menú comunican su estado a los lectores de pantalla */
  function pmMenuA11y() {
    Array.prototype.forEach.call(document.querySelectorAll('.pmm__group:not([data-pm-bound])'), function (g) {
      g.setAttribute('data-pm-bound', '1');
      var sum = g.querySelector('summary');
      var set = function () { if (sum) sum.setAttribute('aria-expanded', g.open ? 'true' : 'false'); };
      g.addEventListener('toggle', set);
      set();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  pmMenu();
  pmMenuA11y();
  document.addEventListener('DOMContentLoaded', function () { pmMenu(); pmMenuA11y(); }, { once: true });

  /* Editor de temas de Shopify: recargar secciones */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* Contenido inyectado después de la carga (apps, secciones diferidas, previsualizaciones) */
  window.PM_REDESIGN_INIT = init;
  if ('MutationObserver' in window) {
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        init(document);
      });
    });
    /* Se apaga a los 20 segundos. Vigilar el body entero para siempre obliga a
       reexaminar todo el documento cada vez que una app inyecta algo, y eso se
       paga en cada interaccion del usuario. Lo que inyectan las apps llega mucho
       antes; para lo demas quedan shopify:section:load y el barrido del scroll. */
    var startMO = function () {
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 20000);
    };
    if (document.body) startMO();
    else document.addEventListener('DOMContentLoaded', startMO, { once: true });
  }

  /* Red de seguridad ligada al scroll: ni secciones invisibles ni contadores a cero
     si el observador no entrega callback (saltos de ancla, scroll rápido, restauración). */
  function pmSweep() {
    Array.prototype.forEach.call(document.querySelectorAll('.pm-reveal:not(.is-in)'), function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in');
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-pm-count]:not([data-pm-ran])'), function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) {
        el.setAttribute('data-pm-ran', '1');
        var to = parseFloat(el.getAttribute('data-pm-count'));
        var dec = parseInt(el.getAttribute('data-pm-dec') || '0', 10);
        el.textContent = to.toFixed(dec).replace('.', ',');
      }
    });
  }
  var pmTicking = false;
  window.addEventListener('scroll', function () {
    if (pmTicking) return;
    pmTicking = true;
    requestAnimationFrame(function () { pmTicking = false; pmSweep(); });
  }, { passive: true });
  setTimeout(pmSweep, 1500);
})();
